import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { AlertService } from '../shared/alert/alert.service';
import { SpinnerService } from '../shared/spinner/spinner.service';

@Component({
  selector: 'forgotten',
  templateUrl: './forgotten-password.component.html'
})
export class ForgottenPasswordComponent {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private spinnerService: SpinnerService
  ) { }

  forgotten(event, mail): void {
    event.preventDefault();
    this.spinnerService.start('Réinitialisation');
    this.authenticationService.forgotten(mail)
      .then(function(response) {
        if (response.success) {
          this.router.navigate(['login']);
          this.alertService.success(response.message);
        } else {
          this.alertService.error(response.message);
        }
        this.spinnerService.stop();
      }.bind(this));
  }


}



// WEBPACK FOOTER //
// ./src/app/forgottenPassword/forgotten-password.component.ts